import React from 'react';
import { Dialogs } from '@leverege/ui-elements';
import RsrcDetailRendererFactory from "../../../components/RsrcDetailRendererFactory.js";
import S from './ImageRsrcModelEditor.css';
import { jsx as _jsx } from "react/jsx-runtime";
class ImageRsrcModelEditor extends React.Component {
  constructor(props) {
    super(props);
    const {
      model,
      rsrc
    } = props;
    this.state = {
      newDataValue: JSON.stringify(model.getData(rsrc), null, 2)
    };
  }
  componentDidUpdate(prevProps) {
    const {
      model,
      rsrc: oldRsrc
    } = prevProps;
    const {
      rsrc
    } = this.props;
    if (model.getData(rsrc) !== model.getData(oldRsrc)) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        newDataValue: JSON.stringify(model.getData(rsrc), null, 2)
      });
    }
  }
  onDataChange = evt => {
    const {
      onChange,
      model,
      rsrc
    } = this.props;
    const nValue = model.setData(rsrc, evt);
    onChange({
      value: nValue
    });
  };
  onEditorValueChange = val => {
    let valid = true,
      value;
    try {
      value = JSON.parse(val);
    } catch (err) {
      valid = false;
    }
    if (valid) {
      this.setState({
        newDataValue: val
      }, () => this.onDataChange(value));
    } else {
      this.setState({
        newDataValue: val
      });
    }
  };
  render() {
    const {
      rsrc,
      detailModel
    } = this.props;
    const editorDetail = RsrcDetailRendererFactory.create(detailModel, {
      rsrc
    });
    return /*#__PURE__*/_jsx("div", {
      className: S.wrapper,
      children: editorDetail
    });
  }
}
ImageRsrcModelEditor.location = 'top';
ImageRsrcModelEditor.install = molten => {
  molten.addPlugin('RsrcModelEditor', {
    type: 'image/png',
    editor: ImageRsrcModelEditor
  });
  molten.addPlugin('RsrcModelEditor', {
    type: 'image/jpeg',
    editor: ImageRsrcModelEditor
  });
};
export default ImageRsrcModelEditor;